<template>
  <div class="bg-rad">
    <div class="rounded bg-white">
        <div class="row">
            <div class="col-md-3 border-right">
                <div class="d-flex flex-column align-items-center text-center">
                    <div v-if="!fileurl">
                        <img
                            v-if="!auth.user.avatar"
                            class="mt-2 p-img"
                            src="../../assets/images/usericone.png"
                            >
                        <img
                            v-if="auth.user.avatar"
                            class="mt-2 p-img"
                            :src="auth.user.avatar"
                            >
                    </div>
                    <div v-else>
                        <img
                            class="mt-2 p-img"
                            :src="fileurl"
                            >
                    </div>
                    <span class="font-weight-bold">{{formPass.last_name + ' ' + formPass.first_name}}</span>
                    <span class="text-black-50">{{formPass.email}}</span>
                    <div>
                        <label
                            class="custom-file-upload btn btn-primary">
                            <input
                                type="file"
                                name="fields[assetsFieldHandle][]"
                                @change="onChange"
                                ref="file"
                                accept=".jpg,.jpeg,.png"
                            />
                            {{$t("message.choose_image")}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-9 border-right">
                <div class="">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h4 class="text-right text-primary">{{$t("message.personal_setting")}}</h4>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.last_name")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.last_name')" 
                                v-model="formPass.last_name"
                                :class="{ 'is-invalid': v$.formPass.last_name.$error }">
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.first_name")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.first_name')"
                                    v-model="formPass.first_name"
                                    :class="{ 'is-invalid': v$.formPass.first_name.$error }">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.gender")}}</label>
                            <select
                                class="form-select"
                                v-model="formPass.gender"
                                placeholder="ភេទ/Gender"
                                title="ភេទ/Gender"
                                :class="{ 'is-invalid': v$.formPass.gender.$error }"
                            >
                                <option selected>Choose...</option>
                                <option value="1">ប្រុស (Male)</option>
                                <option value="2">ស្រី (Female)</option>
                            </select>
                            <!-- <input type="text" class="form-control" 
                                :placeholder="$t('message.gender')" 
                                v-model="formPass.gender"> -->
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.dob")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.dob')"
                                    v-model="formPass.dob"
                                    :class="{ 'is-invalid': v$.formPass.dob.$error }">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.email")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.email')" 
                                v-model="formPass.email"
                                :class="{ 'is-invalid': v$.formPass.email.$error }">
                        </div>
                        <div class="col-md-6">
                            <label class="labels">{{$t("message.phone")}}</label>
                            <input type="text" class="form-control" 
                                    :placeholder="$t('message.phone')"
                                    v-model="formPass.phone"
                                    :class="{ 'is-invalid': v$.formPass.phone.$error }">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <label class="labels">{{$t("message.address")}}</label>
                            <input type="text" class="form-control" 
                                :placeholder="$t('message.address')" 
                                v-model="formPass.address">
                        </div>
                    </div>
                    <div class="mt-5 text-end">
                        <button class="btn btn-primary profile-button" 
                                type="button"
                                @click="actionUpdateInfo">
                                {{$t("message.save")}} <i class="fas fa-save"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    import useVuelidate from "@vuelidate/core";
    import { required } from "@vuelidate/validators";
    import axios from "@/axios";
    export default {
        setup() {
            return {
                v$: useVuelidate()
            };
        },
        data() {
            return {
                filelist: "",
                fileurl: "",
                formPass: {
                    address:"",
                    dob:"",
                    email:"",
                    first_name:"",
                    gender:"",
                    last_name:"",
                    name:"",
                    phone:"",
                }
            };
        },
        validations() {
            return {
                formPass: {
                    dob: { required, $autoDirty: true },
                    email: { required, $autoDirty: true },
                    first_name: { required, $autoDirty: true },
                    gender: { required, $autoDirty: true },
                    last_name: { required, $autoDirty: true },
                    name: { required, $autoDirty: true },
                    phone: { required, $autoDirty: true },
                }
            }
        },
        methods: {
            showLoader() {
                return this.$loading.show({
                // Optional parameters
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
                });
            },
            actionUpdateInfo(){
                this.v$.$validate(); // checks all inputs
                if (!this.v$.$error) {
                    this.$swal
                        .fire({
                            title: this.$t("message.do_you_want_to_save"),
                            showCancelButton: true,
                            confirmButtonText: this.$t("message.yes"),
                            cancelButtonText: this.$t("message.cancel")
                        })
                        .then(async (result) => {
                            if (result.isConfirmed) {
                                let loader = this.showLoader();
                                try {
                                    const respone = await axios.post("update-profile", this.formPass, {
                                    headers: {
                                        Authorization: "Bearer " + this.$store.getters.getAuthToken
                                    }
                                    });
                                    if (respone.status == 200) {
                                        this.$store.dispatch('act_changeUser',respone.data.data);
                                        this.$toast.open({
                                            message: this.$t("message.save_successfully"),
                                            type: "success",
                                            duration: 5000,
                                            dismissible: true,
                                            position: "top-right"
                                        });
                                    }
                                } catch (error) {
                                    this.$toast.open({
                                        message: error.response.data.message,
                                        type: "error",
                                        duration: 5000,
                                        dismissible: true,
                                        position: "top-right"
                                    });
                                }
                                loader.hide();
                            }
                        });
                }
            },
            async onChange() {
                this.filelist = this.$refs.file.files;
                const file = this.filelist[0];
                this.fileurl = URL.createObjectURL(file);
                let photoFormData = new FormData();
                photoFormData.append("file", this.filelist[0]);
                photoFormData.append("object_type", "profile");
                this.uploadPhoto(photoFormData,this.auth.user.id);  
            },
            async uploadPhoto(photoFormData,id){
                photoFormData.append("object_id", id);
                const respone = await axios.post("media-file", photoFormData, {
                    headers: {
                    Authorization: "Bearer " + this.$store.getters.getAuthToken
                    }
                });
                if (respone.status == 201) {
                    this.filelist = "";
                    this.fileurl = "";
                    this.$store.dispatch("act_changeavatar", respone.data.data.filepath);
                }
            },
        },
        computed: {
            auth (){
                return this.$store.getters.getAuth;
            }
        },
        created() {
            this.formPass = {...this.auth.user};
        },
        mounted() {}
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }
    .bg-rad{
        padding: 17px;border: 1px solid #f1f1f1;border-radius: 15px;
    }
    .custom-file-upload {
        border: 1px solid #ccc;
        display: inline-block;
        padding: 6px 12px;
        cursor: pointer;
    }
    .p-img{
        width: 150px;
    }
</style>